import React from 'react';
import { Button } from 'antd';
import {
  RallyStatus,
  useRallyStateQuery,
  useResetRallyMutation,
  useStartRallyMutation,
} from '../../graphql-operations';
import { formatRallyProgress } from './progress';
import './rally.css';

export default function RallyHostPage() {
  const { data, loading, refetch } = useRallyStateQuery({ pollInterval: 1_000 });
  const [reset, resetState] = useResetRallyMutation({ onCompleted: () => refetch() });
  const [start, startState] = useStartRallyMutation({ onCompleted: () => refetch() });
  const race = data?.rallyState;
  const joined = race?.entries.filter((entry) => entry.joined) || [];

  return (
    <main className="rally-host">
      <p className="rally-eyebrow">VÄRDLÄGE</p>
      <h1>Kräft-rally</h1>
      <div className="rally-host-status">
        <strong>{loading ? '…' : race?.status || 'INGET LOPP'}</strong>
        <span>{joined.length} anslutna</span>
      </div>
      <div className="rally-host-actions">
        <Button
          size="large"
          danger={Boolean(race)}
          loading={resetState.loading}
          onClick={() => reset()}
        >
          {race ? 'Skapa om loppet' : 'Skapa lopp'}
        </Button>
        <Button
          type="primary"
          size="large"
          loading={startState.loading}
          disabled={!race || race.status !== RallyStatus.Lobby || joined.length === 0}
          onClick={() => start()}
        >
          Starta loppet
        </Button>
      </div>
      <section className="rally-host-list">
        <h2>Deltagare</h2>
        {joined.map((entry) => (
          <div key={entry.id}>
            <i style={{ background: entry.teamColor }} />
            <span>
              <strong>{entry.name}</strong>
              <small>{entry.team}</small>
            </span>
            <b>{formatRallyProgress(entry.progress)}</b>
          </div>
        ))}
        {!joined.length && <p>Ingen har valt sitt namn ännu.</p>}
      </section>
      {race?.status === RallyStatus.Finished && (
        <a className="rally-host-results" href="/kraft-rally">
          Visa resultatet →
        </a>
      )}
    </main>
  );
}
